import type { FormEvent, HTMLAttributes, TextareaHTMLAttributes } from 'react';

import React, { useEffect, useState } from 'react';

import { classNames } from '../../utils/class-names';
import styles from '../text-input/text-input.module.css';

type OptionalWrapperProps = {
  enabled?: boolean;
} & HTMLAttributes<HTMLDivElement>;

const OptionalWrapper = ({ enabled, ...props }: OptionalWrapperProps) =>
  enabled ? <div role="none" {...props} /> : props.children;

export type TextareaProps = {
  autoSize?: boolean;
} & TextareaHTMLAttributes<HTMLTextAreaElement>;

export function TextArea({
  autoSize,
  className,
  style,
  onInput,
  disabled,
  placeholder,
  children,
  ...props
}: TextareaProps) {
  const [value, setValue] = useState(props.value);

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const handleInput = (event: FormEvent<HTMLTextAreaElement>) => {
    setValue(event.currentTarget.value);
    onInput?.(event);
  };

  return (
    <OptionalWrapper
      enabled={Boolean(children)}
      className={classNames(styles.wrapper, styles.input, props.readOnly && styles.readOnly, className)}
      style={style}
    >
      <OptionalWrapper enabled={autoSize} className={styles.autoSizer} data-value={value}>
        <textarea
          className={classNames(styles.baseInput, !children && styles.onlyInput, !children && className)}
          style={children ? undefined : style}
          onInput={handleInput}
          placeholder={disabled ? '' : placeholder}
          disabled={disabled}
          {...props}
        />
      </OptionalWrapper>

      {children}
    </OptionalWrapper>
  );
}
